import { getReportById } from "@/services/reports.service";
import { useQuery } from "@tanstack/react-query";

export const useReport = (id, options = {}) => {
  return useQuery({
    queryKey: ["report", id],
    queryFn: () => getReportById(id),
    enabled: Boolean(id),
    ...options,
  });
};
